module.exports = __webpack_public_path__ + "img/male10.e0d82e35.jpeg";